/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAlignLeft,
  faArrowLeft,
  faArrowUpFromBracket,
  faArrowsSplitUpAndLeft,
  faAt,
  faBookmark,
  faBriefcase,
  faCalendarPlus,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faCopy,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faFileExcel,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFolderOpen,
  faGlobe,
  faGripLines,
  faHandPointRight,
  faImage,
  faLink,
  faListCheck,
  faListUl,
  faObjectGroup,
  faPaintbrush,
  faPaperclip,
  faPaste,
  faPencil,
  faPlus,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScroll,
  faShareNodes,
  faSquarePlus,
  faThumbsDown,
  faThumbsUp,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserPlus,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faGoogleDrive } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faAlignLeft,
  faArrowLeft,
  faArrowUpFromBracket,
  faArrowsSplitUpAndLeft,
  faAt,
  faBookmark,
  faBriefcase,
  faCalendarPlus,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faCopy,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEnvelope,
  faFileExcel,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFolderOpen,
  faGlobe,
  faGripLines,
  faHandPointRight,
  faImage,
  faLink,
  faListCheck,
  faListUl,
  faObjectGroup,
  faPaintbrush,
  faPaperclip,
  faPaste,
  faPencil,
  faPlus,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScroll,
  faShareNodes,
  faSquarePlus,
  faThumbsDown,
  faThumbsUp,
  faTrashCan,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserPlus,
  faWandMagicSparkles,
  faXmark,
  faGoogleDrive
);

export default FontAwesomeIcon;
